import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import Swal from "sweetalert2";
import config from "../../config/apiService.json";
import fetchData from "../../utils/fetchData";
import {deleteMethod} from "../../utils/httpServices";

const UseMediasAndEvents = () => {
    const navigate = useNavigate("")
    const [data, setData] = useState([]);
    const [isLoading, setLoading] = useState(true);

    const {mediaEvents, administrative} = config;
    const {mediaEvents: deleteMediaEventsApiEndPoint} = administrative;

    const getData = async () => {
        const result = await fetchData(mediaEvents);
        setData(result);
        setLoading(false);
    }

    useEffect(() => {
        getData();
    }, []);

    const handleDelete = (id) => {
        try {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#354e80',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const response = await deleteMethod(`${deleteMediaEventsApiEndPoint}/${id}`);
                    getData();
                    if (response) {
                        Swal.fire(
                            'Deleted!',
                            'Your file has been deleted.',
                            'success'
                        )
                    }
                }
            });
        } catch (ex) {
            toast.error(ex.response.data);
        }
    }

    const handleAdd = () => {
        navigate("/admin/media-events/0");
    }

    return {data, isLoading, handleAdd, handleDelete}
};

export default UseMediasAndEvents;
